/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface WhatsAppLinkRequest
 */
export interface WhatsAppLinkRequest {
  /**
   *
   * @type {string}
   * @memberof WhatsAppLinkRequest
   */
  challengeToken: string;
  /**
   *
   * @type {string}
   * @memberof WhatsAppLinkRequest
   */
  action: WhatsAppLinkRequestActionEnum;
  /**
   *
   * @type {boolean}
   * @memberof WhatsAppLinkRequest
   */
  explicitConfirm?: boolean;
}

/**
 * @export
 */
export const WhatsAppLinkRequestActionEnum = {
  Inspect: "inspect",
  Prepare: "prepare",
  Confirm: "confirm",
  Cancel: "cancel",
} as const;
export type WhatsAppLinkRequestActionEnum =
  (typeof WhatsAppLinkRequestActionEnum)[keyof typeof WhatsAppLinkRequestActionEnum];

/**
 * Check if a given object implements the WhatsAppLinkRequest interface.
 */
export function instanceOfWhatsAppLinkRequest(
  value: object
): value is WhatsAppLinkRequest {
  if (!("challengeToken" in value) || value["challengeToken"] === undefined)
    return false;
  if (!("action" in value) || value["action"] === undefined) return false;
  return true;
}

export function WhatsAppLinkRequestFromJSON(json: any): WhatsAppLinkRequest {
  return WhatsAppLinkRequestFromJSONTyped(json, false);
}

export function WhatsAppLinkRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): WhatsAppLinkRequest {
  if (json == null) {
    return json;
  }
  return {
    challengeToken: json["challenge_token"],
    action: json["action"],
    explicitConfirm:
      json["explicit_confirm"] == null ? undefined : json["explicit_confirm"],
  };
}

export function WhatsAppLinkRequestToJSON(json: any): WhatsAppLinkRequest {
  return WhatsAppLinkRequestToJSONTyped(json, false);
}

export function WhatsAppLinkRequestToJSONTyped(
  value?: WhatsAppLinkRequest | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    challenge_token: value["challengeToken"],
    action: value["action"],
    explicit_confirm: value["explicitConfirm"],
  };
}
